var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('Transition',{attrs:{"appear":""}},[_c('div',{staticClass:"text-center"},[_c('b-spinner',{staticStyle:{"width":"4rem","height":"4rem"},attrs:{"variant":"primary","label":"Text Centered"}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }